import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const CustomerOTPRBAC = {
  pageID: 'a925c28d93c9e0d7bcf3817374170f69',
  elementID: {
    View: 'f48fd9b6457c6eefa40d1ce45fe0c212',
    ViewDetail: '1838ed6d6cf5fb4baf298ccdff830615',
  },
} as const

export const useRBACCustomerOTPPage = createUseRBAC(CustomerOTPRBAC.elementID)

export type UseRBACCustomerOTPPageType = ReturnType<typeof useRBACCustomerOTPPage>
